import { ReactNode } from 'react'
import { cn } from '@/lib/misc/Utils'

interface GuestLayoutProps {
  children: ReactNode
  loading?: boolean
  slim?: boolean
  forceShowLogo?: boolean
  splitPanel?: boolean
  containerClassName?: string
}

const GuestLayout = ({
  children,
  loading,
  slim,
  forceShowLogo = false,
  splitPanel = false,
  containerClassName = '',
}: GuestLayoutProps) => (
  <div className="relative isolate flex min-h-dvh items-center justify-center overflow-hidden px-4 py-10 sm:px-6 lg:px-8">
    <div
      aria-hidden
      className="pointer-events-none absolute inset-0 bg-gradient-to-b from-accent-90 via-[#1a0b26] to-[#0a0410]"
    />
    <div
      aria-hidden
      className={cn(
        'pointer-events-none absolute left-1/2 top-0 size-[min(92vw,36rem)] -translate-x-1/2 -translate-y-[28%] rounded-full bg-accent-100/25 blur-[100px] transition-opacity duration-700',
        loading ? 'opacity-100' : 'opacity-80'
      )}
    />
    <div
      aria-hidden
      className="pointer-events-none absolute -right-20 bottom-0 size-[min(70vw,28rem)] translate-y-1/4 rounded-full bg-brand-5/20 blur-[90px]"
    />
    <div
      aria-hidden
      className="pointer-events-none absolute -left-16 top-1/3 size-72 rounded-full bg-brand-2/10 blur-[72px]"
    />
    <div
      aria-hidden
      className="absolute inset-0 bg-[linear-gradient(to_right,rgba(255,255,255,0.04)_1px,transparent_1px),linear-gradient(to_bottom,rgba(255,255,255,0.04)_1px,transparent_1px)] [background-size:44px_44px] mask-[radial-gradient(ellipse_at_center,black_20%,transparent_70%)]"
    />

    <div
      className={cn(
        'relative z-10 w-full',
        slim ? 'max-w-md' : splitPanel ? 'max-w-5xl lg:max-w-6xl' : 'max-w-md',
        'rounded-3xl border border-white/20 shadow-[0_32px_64px_-20px_rgba(5,0,10,0.75)] bg-surface/10',
        containerClassName
      )}
    >
      <div
        className={cn(
          'mx-auto items-center justify-center pt-3.5 pb-1.5 h-10 w-full rounded-t-3xl flex',
          !forceShowLogo && 'lg:hidden'
        )}
      >
        <img
          className="size-full object-contain transition-all duration-700"
          src="/images/logo_interlink.svg"
          alt="inter.link"
        />
      </div>
      <div className="p-2 rounded-3xl flex">
        <div className="bg-surface rounded-2xl flex-1">{children}</div>
      </div>
    </div>
  </div>
)

export default GuestLayout
